import deserialize from 'app/utils/deserialize'
import { fetch } from 'app/utils/data'

export default {
  namespaced: true,

  state: {
    timeSeries: null,
    bandwidthByIp: null,
    summary: null,
    logs: null,
    loading: false,
    error: null
  },

  getters: {
    timeSeries: (state) => state.timeSeries,
    bandwidthByIp: (state) => state.bandwidthByIp,
    summary: (state) => state.summary,
    logs: (state) => state.logs,
    loading: (state) => state.loading,
    error: (state) => state.error
  },

  mutations: {
    setLoading(state, loading) {
      state.loading = loading
    },

    setError(state, error) {
      state.error = error
    },

    setTimeSeries(state, data) {
      state.timeSeries = data
    },

    setBandwidthByIp(state, data) {
      state.bandwidthByIp = data
    },

    setSummary(state, data) {
      state.summary = data
    },

    setLogs(state, data) {
      state.logs = data
    },

    resetState(state) {
      state.timeSeries = null
      state.bandwidthByIp = null
      state.summary = null
      state.logs = null
      state.loading = false
      state.error = null
    }
  },

  actions: {
    fetchTimeSeries({ commit }, { entitlement_token, interval, start_time, end_time }) {
      return fetch({
        url: '/api/admin/cloudsmith-analytics/time-series',
        params: { entitlement_token, interval, start_time, end_time }
      }).then((response) => {
        return deserialize(response.data).then((data) => {
          commit('setTimeSeries', data)
          return data
        })
      })
    },

    fetchBandwidthByIp({ commit }, { entitlement_token, start_time, end_time }) {
      return fetch({
        url: '/api/admin/cloudsmith-analytics/bandwidth-by-ip',
        params: { entitlement_token, start_time, end_time }
      }).then((response) => {
        return deserialize(response.data).then((data) => {
          commit('setBandwidthByIp', data)
          return data
        })
      })
    },

    fetchSummary({ commit }, { entitlement_token, start_time, end_time }) {
      return fetch({
        url: '/api/admin/cloudsmith-analytics/summary',
        params: { entitlement_token, start_time, end_time }
      }).then((response) => {
        return deserialize(response.data).then((data) => {
          commit('setSummary', data)
          return data
        })
      })
    },

    // Not yet wired into the UI — plumbing for a future raw download logs table
    fetchLogs({ commit }, { entitlement_token, start_time, end_time, limit }) {
      const params = { entitlement_token, start_time, end_time }
      if (limit) params.limit = limit

      return fetch({
        url: '/api/admin/cloudsmith-analytics/logs',
        params
      }).then((response) => {
        return deserialize(response.data).then((data) => {
          commit('setLogs', data)
          return data
        })
      })
    },

    fetchAll({ commit, dispatch }, params) {
      commit('setLoading', true)
      commit('setError', null)

      return Promise.all([dispatch('fetchTimeSeries', params), dispatch('fetchBandwidthByIp', params), dispatch('fetchSummary', params)])
        .catch((error) => {
          commit('setError', error.response ? error.response.data : error.message)
          throw error
        })
        .finally(() => {
          commit('setLoading', false)
        })
    }
  }
}
